import React from 'react';
import { MessageCircle, Image, Video, Shield, Search, Users } from 'lucide-react';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: <MessageCircle className="w-6 h-6" />,
    title: "AI Chat Interface",
    description: "Chat with an AI assistant powered by Pollinations.AI API with a clean, minimal interface and real-time conversation experience."
  },
  {
    icon: <Image className="w-6 h-6" />,
    title: "Text-to-Image Generation",
    description: "Generate stunning images from text prompts using AI. Create pictures with natural language descriptions and direct URL generation."
  },
  {
    icon: <Video className="w-6 h-6" />,
    title: "Video Generation",
    description: "Create videos from text descriptions using TextToVideo V2 API. Supports natural language video requests with integrated playback."
  },
  {
    icon: <Shield className="w-6 h-6" />,
    title: "OSINT Capabilities",
    description: "Extract and analyze personal information from text including phone numbers, vehicle registration, UPI IDs, and Aadhaar numbers."
  },
  {
    icon: <Search className="w-6 h-6" />,
    title: "Web Search",
    description: "Search the internet using DuckDuckGo and news APIs. Get organized search results with AI analysis for comprehensive answers."
  },
  {
    icon: <Users className="w-6 h-6" />,
    title: "Multi-Chat Support",
    description: "Create and manage multiple separate chat conversations with local chat history storage and seamless switching between sessions."
  }
];

export function Features4() {
  return (
    <section className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-instrument-sans font-semibold leading-7 text-primary uppercase tracking-[0.51em]">Everything you need</h2>
          <p className="mt-2 text-3xl font-instrument-serif font-semibold tracking-tight text-foreground sm:text-4xl text-balance">
            Powerful AI assistant with advanced capabilities
          </p>
          <p className="mt-6 text-lg font-instrument-sans font-light leading-8 text-muted-foreground">
            Caude combines multiple AI capabilities in one intelligent interface. From chat and content creation to analysis and research.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
            {features.map((feature, index) => (
              <div key={index} className="relative pl-16">
                <dt className="text-lg font-instrument-serif font-semibold leading-7 text-foreground">
                  <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-primary">
                    <div className="text-white">{feature.icon}</div>
                  </div>
                  {feature.title}
                </dt>
                <dd className="mt-2 text-base font-instrument-sans leading-7 text-muted-foreground text-balance">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}